import { usePageTitle } from "@/hooks/usePageTitle";

export function PrivacyPolicyPage() {
  usePageTitle("Privatumo politika");

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="mb-8 text-3xl font-bold text-gray-900">
        Privatumo politika
      </h1>

      <div className="space-y-8 text-gray-600">
        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            1. Bendrosios nuostatos
          </h2>
          <p>
            Ši privatumo politika aprašo, kaip Boardo (toliau – „Platforma")
            renka, naudoja ir saugo jūsų asmens duomenis. Naudodamiesi
            Platforma, jūs sutinkate su šia privatumo politika.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            2. Renkami duomenys
          </h2>
          <p className="mb-2">
            Registruodamiesi ir naudodamiesi Platforma, galime rinkti šiuos
            duomenis:
          </p>
          <ul className="ml-6 list-disc space-y-1">
            <li>Vardas ir el. pašto adresas</li>
            <li>Profilio nuotrauka</li>
            <li>Skelbimų ir žinučių turinys</li>
            <li>Prisijungimo duomenys (IP adresas, naršyklės tipas)</li>
          </ul>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            3. Duomenų naudojimas
          </h2>
          <p className="mb-2">Jūsų duomenis naudojame šiais tikslais:</p>
          <ul className="ml-6 list-disc space-y-1">
            <li>Paskyros sukūrimui ir valdymui</li>
            <li>Skelbimų talpinimui ir rodymui</li>
            <li>Žinučių siuntimui tarp naudotojų</li>
            <li>Platformos tobulinimui ir saugumui užtikrinti</li>
          </ul>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            4. Duomenų saugojimas
          </h2>
          <p>
            Jūsų asmens duomenys saugomi saugiuose serveriuose. Taikome
            tinkamas technines ir organizacines priemones duomenims apsaugoti
            nuo neteisėtos prieigos, praradimo ar sunaikinimo.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            5. Duomenų perdavimas trečiosioms šalims
          </h2>
          <p>
            Jūsų asmens duomenų neperduodame trečiosioms šalims, išskyrus
            atvejus, kai to reikalauja teisės aktai arba tai būtina Platformos
            paslaugoms teikti.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            6. Slapukai
          </h2>
          <p>
            Platforma naudoja slapukus (cookies) prisijungimo sesijai palaikyti
            ir naudotojo patirčiai gerinti. Naudodamiesi Platforma, sutinkate su
            slapukų naudojimu.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            7. Jūsų teisės
          </h2>
          <p className="mb-2">Jūs turite teisę:</p>
          <ul className="ml-6 list-disc space-y-1">
            <li>Susipažinti su savo asmens duomenimis</li>
            <li>Prašyti ištaisyti netikslius duomenis</li>
            <li>Prašyti ištrinti savo paskyrą ir duomenis</li>
            <li>Atšaukti sutikimą dėl duomenų tvarkymo</li>
          </ul>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            8. Kontaktai
          </h2>
          <p>
            Dėl privatumo klausimų kreipkitės el. paštu{" "}
            <a
              href="mailto:info@boardo.lt"
              className="text-primary-800 hover:text-primary-700"
            >
              info@boardo.lt
            </a>
            .
          </p>
        </section>

        <p className="pt-4 text-sm text-gray-400">
          Paskutinį kartą atnaujinta: 2026 m. vasario mėn.
        </p>
      </div>
    </div>
  );
}
